export const regular = {
  // 验证自然数
  naturalNumber: /^(([0-9]*[1-9][0-9]*)|(0+))$/,
  naturalNumberMsg: '请输入自然数',
  // 英文
  english: /^.[A-Za-z]+$/,
  englishMsg: '请输入英文字符',
  // 手机
  mobile: /^1(3|4|5|6|7|8|9)\d{9}$/,
  mobileMsg: '请输入正确的手机号',
  // 座机
  telephone: /^\d{3}-\d{7,8}|\d{4}-\d{7,8}$/,
  telephoneMsg: '请输入正确的座机号',
  // 座机或手机号
  telemobile: /^((0\d{2,6}(-)?\d{2,30})|[+]{0,1}(\d+))$/,
  telemobileMsg: '请输入正确的手机号或座机号',
  // 银行卡号码
  bankCard: /^[0-9]\d{9,21}$/,
  bankCardMsg: '请输入正确的银行卡号码',
  // 证件号码
  IDNumber: /^[a-z0-9A-Z]{0,50}$/,
  IDNumberMsg: '请输入正确的证件号码',
  // 身份证号码,包括15位和18位的
  IDCard:
    /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{7}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}$)/,
  IDCardMsg: '请输入正确的身份证号码',
  // QQ号码
  qq: /^[1-9]\d{4,11}$/,
  qqMsg: '请输入正确的QQ号码',
  // 网址, 仅支持http和https开头的
  url: /^(http|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-.,@?^=%&:/~+#]*[\w\-@?^=%&/~+#])?$/,
  urlMsg: '请输入以http和https开头的网址',
  // 0到20位的英文字符和数字
  enNum: /^[a-z0-9A-Z]+$/,
  enNumMsg: '只能输入字母和数字，区分大小写',
  // 0到20位的英文字符和数字
  enNum0to20: /^[a-z0-9A-Z]{0,20}$/,
  enNum0to20Msg: '请输入20位以内的英文字符和数字',
  // 2到100位的中英文字符和空格
  cnEnSpace2to100: /^[a-zA-Z\u4E00-\u9FA5\s*]{2,100}$/,
  cnEnSpace2to100Msg: '请输入2到100位的中英文字符和空格',
  // 数字和换行符
  numLinefeed: /^[0-9\n*]+$/,
  numLinefeedMsg: '请输入数字和换行符',
  // 255位以内的字符
  char0to255: /^.{0,255}$/,
  char0to255Msg: '请输入255位以内的字符',
  // 纳税人识别号
  trn: /^[0-9A-HJ-NPQRTUWXY]{2}\d{6}([0-9A-HJ-NPQRTUWXY]{7}|[0-9A-HJ-NPQRTUWXY]{10}|[0-9A-HJ-NPQRTUWXY]{12})$/,
  trnMsg: '请输入正确的纳税人识别号',
  // 匹配任务编号
  taskNumber: /^(RWSH){1}[0-9]{18}$/,
  taskMsg: '请输入正确格式的任务编号',
  // 邮箱
  email: /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,5}$/,
  emailMsg: '请输入正确的电子邮箱',
  // 匹配金额(两位小数点)
  amountNum: /^\d+(\.\d{1,2})?$/,
  amountNumMsg: '请输入正确的金额(两位小数)',
}
